import { Box } from "@mui/material";
import React from "react";
import moment from "moment";
import { milestoneStatusStyleArray, snagStatusStyleArray } from "../../config";
import styles from "../../styles";

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

function SnagList({ snag, onClick }) {
  return (
    <>
      <Box
        key={snag.id}
        display="flex"
        flexDirection="row"
        gap={2}
        border="1px solid rgba(18, 18, 21, 0.10)"
        borderRadius="12px"
        padding="2vh 1.5vw"
        marginBottom="16px"
        onClick={() => onClick && onClick(snag)}
        sx={{ cursor: "pointer" }}
      >
        <div
          style={{
            position: "relative",
            borderRadius: "16px",
            overflow: "hidden", // ensures children respect the border radius
            width: "160px",
            height: "160px",
          }}
        >
          <img
            src={snag.image_url}
            alt="Snag"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
          {snag.markup && (
            <Box
              sx={{
                position: "absolute",
                bottom: 12,
                right: 8,
                backgroundColor: "#3B82F6",
                color: "#fff",
                width: 24,
                height: 24,
                borderRadius: "50%",
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {snag.markup}
            </Box>
          )}
        </div>

        <Box
          flex="1"
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
        >
          <Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              gap={1}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <h3
                  style={{
                    color: "#0D0D0E",
                    fontFamily: "Inter Tight",
                    fontWeight: 500,
                    letterSpacing: ".5px",
                    marginRight: "1vw",
                  }}
                >
                  {snag.category}
                </h3>{" "}
                <span
                  style={{
                    backgroundColor: "#F5F5F5",
                    borderRadius: "12px",
                    padding: ".5vh 1vw",
                    fontSize: "12px",
                    color: "#0D0D0E",
                    fontWeight: 500,
                  }}
                >
                  {snag.room}
                </span>
              </div>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <Box
                  sx={{
                    width: "15px",
                    height: "15px",
                    borderRadius: "50%",
                    border: "3px solid rgb(229, 229, 229)",
                    backgroundColor:
                      snagStatusStyleArray.find(
                        (style) => style.status === snag?.status
                      )?.backgroundColor || "#FFAD5C",
                  }}
                />
                <Box
                  sx={{
                    fontSize: "14px",
                    color: "#0D0D0E",
                  }}
                >
                  {getStatusDisplayText(snag?.status)}
                </Box>
              </Box>
            </Box>

            <p
              style={{
                margin: "1.5vh 0",
                fontSize: "14px",
                color: "#0D0D0E",
                flexGrow: 1,
                lineHeight: "22px",
                fontWeight: 400,
              }}
            >
              {snag.description}
            </p>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
            marginTop="auto"
          >
            <span
              style={{ fontSize: "14px", fontWeight: 500, color: "#0D0D0E" }}
            >
              {moment(snag.updated_at).format("DD MMM, YYYY")}
            </span>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default SnagList;
